<template>
  <!-- 实名认证 -->
  <div class="con">
    <van-action-sheet v-model="show" @close="close">
      <div class="content">
        <div class="top_bg">
          <div class="font_title1 font12 font_weight500 colof line_height_17">
            海关要求
          </div>
          <div class="font_title font18 font_weight500 line_height_25 colof">
            购买跨境商品需要实名认证
          </div>
          <img
            src="@/assets/pay/icon_id_close@2x.png"
            alt=""
            class="icon_close"
            @click="close"
          />
        </div>
        <div class="con_con">
          <div class="font12 font_weight400 colo087 text_left">
            请填写实名信息，并使用实名人的账户付款：
          </div>
          <van-field
            v-model="preCheckout.idcardName"
            name="姓    名"
            label="姓    名"
            placeholder="请输入您的真实姓名"
            :rules="[{ required: true, message: '请填写姓名' }]"
            @input="inputName"
          />
          <van-field
            v-model="preCheckout.idcardNo"
            name="身份证"
            label="身份证"
            placeholder="请输入您的身份证号"
            :rules="[{ required: true, message: '请填写身份证' }]"
            @input="inputId"
          />
          <div
            class="font14 font_weight500 colof line_height_40 btn"
            @click="sure"
          >
            确认
          </div>
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: true,
      username: "",
      idNum: ""
    };
  },
  computed: {
    preCheckout() {
      const fast = this.$store.state.order.fast;
      return fast;
    }
  },
  methods: {
    close() {
      this.show = true;
      this.$emit("closeSheet");
    },
    sure() {
      this.show = true;
      this.$emit("sure");
    },
    inputName(name) {
      console.log(name);
      this.$emit("inputName", name);
    },
    inputId(id) {
      this.$emit("inputId", id);
    }
  }
};
</script>

<style lang="less" scoped>
.con {
  ::v-deep .van-popup {
    background-color: transparent !important;
  }
  .top_bg {
    background: url("~@/assets/pay/id_bg@2x.png") 0 0 no-repeat;
    background-size: 100% 100%;
    position: relative;
    text-align: center;
    .font_title1 {
      padding-top: 3px;
    }
    .font_title {
      padding: 19px 0 35px;
    }
    .icon_close {
      position: absolute;
      top: 13px;
      right: 10px;
      width: 24px;
    }
  }
  .con_con {
    background: #fff;
    padding: 12px;
    ::v-deep .van-cell {
      background: #edeeef;
      border-radius: 19px;
      padding: 9px 16px;
      margin: 18px 0 12px;
    }
    ::v-deep .van-field__label {
      width: 70px;
      margin-right: 0;
    }
  }
  .btn {
    background: linear-gradient(90deg, #e1c49d 0%, #bf9264 100%);
    border-radius: 20px;
    text-align: center;
  }
}

b,
u,
i,
span {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}
.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: "";
  clear: both;
  height: 0;
}
.left {
  float: left;
}
.right {
  float: right;
}
/* 字体大小 */
.font9 {
  -webkit-text-size-adjust: none;
  font-size: 9px;
}
.font10 {
  font-size: 10px;
}
.font0 {
  font-size: 0;
}
.font12 {
  font-size: 12px;
}
.font14 {
  font-size: 14px;
}
.font16 {
  font-size: 16px;
}
.font18 {
  font-size: 18px;
}
.font20 {
  font-size: 20px;
}
.font22 {
  font-size: 22px;
}
.font24 {
  font-size: 24px;
}
.font28 {
  font-size: 28px;
}
/* 字体颜色 */
.colo0 {
  color: #000;
}
.colo087 {
  color: rgba(0, 0, 0, 0.87);
}
.colo055 {
  color: rgba(0, 0, 0, 0.55);
}
.colo050 {
  color: rgba(0, 0, 0, 0.5);
}
.colo037 {
  color: rgba(0, 0, 0, 0.37);
}
.colo038 {
  color: rgba(0, 0, 0, 0.38);
}
.colo2 {
  color: #222;
}
.colo255 {
  color: rgba(34, 34, 34, 0.55);
}
.colo287 {
  color: rgba(34, 34, 34, 0.87);
}
.colof {
  color: #fff;
}
.colof87 {
  color: rgba(255, 255, 255, 0.87);
}
.colof00 {
  color: #f00;
}
/* 行高 */
.line_height_14 {
  line-height: 14px;
}
.line_height_16 {
  line-height: 16px;
}
.line_height_17 {
  line-height: 16px;
}
.line_height_18 {
  line-height: 18px;
}
.line_height_19 {
  line-height: 19px;
}
.line_height_20 {
  line-height: 20px;
}
.line_height_22 {
  line-height: 22px;
}
.line_height_24 {
  line-height: 24px;
}
.line_height_25 {
  line-height: 25px;
}
.line_height_30 {
  line-height: 30px;
}
.line_height_32 {
  line-height: 32px;
}
.line_height_34 {
  line-height: 34px;
}
.line_height_40 {
  line-height: 40px;
}
.line_height_48 {
  line-height: 48px;
}
.line_height_50 {
  line-height: 50px;
}
/* 字体粗细 */
.font_weight400 {
  font-weight: 400;
}
.font_weight500 {
  font-weight: 500;
}
.font_weight600 {
  font-weight: 600;
}
/* 文字居中效果 */
.text_center {
  text-align: center;
}
.text_left {
  text-align: left;
}
.text_right {
  text-align: right;
}
/* 线 */
.border_bottom1px {
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
.border_top1px {
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}
.border_bottom1px_shadow {
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.06);
}
.border_top1px_shadow {
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.06);
}

/* 两行点点点点 */
.font_line_2 {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.font_line_1 {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.loading_toast {
  width: 45px;
  height: 45px;
  max-width: 45px;
  min-height: 45px;
  font-size: 12px;
}
</style>
